import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StateService } from '@uirouter/angular';
import { SharedAjsService } from 'src/app/core/services/shared-ajs.service';

@Component({
  selector: 'app-assessments-sync-message',
  templateUrl: './assessments-sync-message.component.html',
  styleUrls: ['./assessments-sync-message.component.css']
})
export class AssessmentsSyncMessageComponent implements OnInit, OnDestroy {

  showSyncMessage = false;
  displayNavigationToAssessments = false;
  syncMessage: string;
  private syncMessageSubscription: Subscription;

  constructor(
    private $state: StateService,
    private sharedAjsService: SharedAjsService
  ) { }

  ngOnInit() {
    this.syncMessageSubscription = this.sharedAjsService.receiveAssessmentsSyncMessage().subscribe((message: string) => {
      this.displayNavigationToAssessments = !message.includes('Syncing Assessments');
      this.syncMessage = this.displayNavigationToAssessments ? message + ' Go to Assessments' : message;
      this.showSyncMessage = true;
    });
  }

  ngOnDestroy() {
    this.syncMessageSubscription.unsubscribe();
  }

  goToAssessments() {
    if (this.$state.current.name === 'missioncontrol.assessmentManagement') {
      this.$state.reload();
    } else {
      this.$state.go('missioncontrol.assessmentManagement', { reload: true });
    }
    this.showSyncMessage = false;
  }

  toggleSyncMessage() {
    this.showSyncMessage = !this.showSyncMessage;
  }
}
